(function () {
    'use strict';

    /*
     MyOrderLogController
    -------------------------------------------------------------------------- */

    angular
        .module('PublicApp.Order.log', [])
        .controller('MyOrderLogController', [
            '$scope',
            '__Form',
            MyOrderLogController
        ]);

    /**
      * MyOrderLogController for manage product list
      *
      * @inject $scope
      * @inject __Form
      * 
      * @return void
      *-------------------------------------------------------- */


    function MyOrderLogController($scope, __Form) {

        var scope = this;

        scope = __Form.setup(scope, 'cart_order_log_dialog_form', 'cartData', {
            secured: true
        });

        scope.ngDialogData = $scope.ngDialogData;
        scope.order = scope.ngDialogData.order;
        scope.orderLog = scope.ngDialogData.orderLog;

        /**
          * Close dialog and return promise object
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.close = function () {
            $scope.closeThisDialog();
        }

    };

})();